<template>
  <div id="voyage-plan-detail">
    <div class="voyage-plan-detail-inner" :class="{'mobile': isMobileDevice}">
      <div class="vessel-name-title-area">
        <div class="vessel-name-text aisea-text-18-400-black">
          {{ vesselName }}
        </div>
        <router-link :to="{ name: 'addon-eco-ship-voyage-plan-list', query: paramsToList }" class="back-to-list-button">
          <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
          <span>一覧へ戻る</span>
        </router-link>
      </div>
      <div class="upper-control-area aisea-text-14-400-black">
        <div class="control-area-block vs-sm-12">
          <div class="control-area-label" v-if="!isMobileDevice">
            航海日時
          </div>
          <div class="control-area-text">
            {{ voyageDateTime }}
          </div>
        </div>
        <div class="control-area-block">
          <div class="control-area-label">
            航路
          </div>
          <div class="control-area-text">
            {{ seaRouteDestination }}
          </div>
          <div class="control-area-label">
            操船者
          </div>
          <div class="control-area-text">
            {{ pilot }}
          </div>
        </div>
      </div>
      <div class="main-voyage-plan-container mobile" v-if="isMobileDevice">
        <div id="voyage-plan-map">

        </div>
        <div class="voyage-plan-control-wrapper">
          <div class="voyage-plan-control-area">
            <div class="control-area-switch-container aisea-text-14-400-white">
              <div class="upper-switch-container">
                <div class="yellow-circle"></div>
                <span>実績航路</span>
                <vs-switch class="control-switch" color="#2D9CDB" v-model="actualSeaRouteSwitch"/>
              </div>
              <div class="focused-route-info-text">{{actualFocusedSeaRoutePoint.date}}</div>
              <div class="focused-route-info-text">速力：{{actualFocusedSeaRoutePoint.speed ? actualFocusedSeaRoutePoint.speed + "KN" : null}}</div>
              <div class="focused-route-info-text">時間：{{actualFocusedSeaRoutePoint.time}}</div>
              <div class="focused-route-info-text">距離：{{actualFocusedSeaRoutePoint.distance ? actualFocusedSeaRoutePoint.distance + "NM" : null}}</div>
            </div>
            <div class="control-area-switch-container">
              <div class="upper-switch-container">
                <div class="blue-circle"></div>
                <span>ポラリス航路</span>
                <vs-switch class="control-switch" color="#2D9CDB" v-model="polarisSeaRouteSwitch"/>
              </div>
              <div class="focused-route-info-text">{{polarisFocusedSeaRoutePoint.date}}</div>
              <div class="focused-route-info-text">速力：{{polarisFocusedSeaRoutePoint.speed ? polarisFocusedSeaRoutePoint.speed + "KN" : null}}</div>
              <div class="focused-route-info-text">時間：{{polarisFocusedSeaRoutePoint.time}}</div>
              <div class="focused-route-info-text">距離：{{polarisFocusedSeaRoutePoint.distance ? polarisFocusedSeaRoutePoint.distance + "NM" : null}}</div>
            </div>
            <div class="control-area-switch-container">
              <div class="upper-switch-container">
                <div class="gray-circle"></div>
                <span>計画航路</span>
                <vs-switch class="control-switch" color="#2D9CDB" v-model="plannedSeaRouteSwitch"/>
              </div>
              <div>距離：{{plannedFocusedSeaRoutePoint.distance}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-voyage-plan-container" v-else>
        <div id="voyage-plan-map">

        </div>

        <div class="voyage-plan-control-area">
          <div class="control-area-switch-container aisea-text-14-400-white">
            <div class="upper-switch-container">
              <div class="yellow-circle"></div>
              <span>実績航路</span>
              <vs-switch class="control-switch" color="#2D9CDB" v-model="actualSeaRouteSwitch"/>
            </div>
            <div class="focused-route-info-text">{{actualFocusedSeaRoutePoint.date}}</div>
            <div class="focused-route-info-text">速力：{{actualFocusedSeaRoutePoint.speed ? actualFocusedSeaRoutePoint.speed + "KN" : null}}</div>
            <div class="focused-route-info-text">時間：{{actualFocusedSeaRoutePoint.time}}</div>
            <div class="focused-route-info-text">距離：{{actualFocusedSeaRoutePoint.distance ? actualFocusedSeaRoutePoint.distance + "NM" : null}}</div>
          </div>
          <div class="control-area-switch-container">
            <div class="upper-switch-container">
              <div class="blue-circle"></div>
              <span>ポラリス航路</span>
              <vs-switch class="control-switch" color="#2D9CDB" v-model="polarisSeaRouteSwitch"/>
            </div>
            <div class="focused-route-info-text">{{polarisFocusedSeaRoutePoint.date}}</div>
            <div class="focused-route-info-text">速力：{{polarisFocusedSeaRoutePoint.speed ? polarisFocusedSeaRoutePoint.speed + "KN" : null}}</div>
            <div class="focused-route-info-text">時間：{{polarisFocusedSeaRoutePoint.time}}</div>
            <div class="focused-route-info-text">距離：{{polarisFocusedSeaRoutePoint.distance ? polarisFocusedSeaRoutePoint.distance + "NM" : null}}</div>
          </div>
          <div class="control-area-switch-container">
            <div class="upper-switch-container">
              <div class="gray-circle"></div>
              <span>計画航路</span>
              <vs-switch class="control-switch" color="#2D9CDB" v-model="plannedSeaRouteSwitch"/>
            </div>
            <div>距離：{{plannedFocusedSeaRoutePoint.distance}}</div>
          </div>
        </div>

      </div>
      <div class="footer-voyage-plan-area">
        <div class="data-table">
          <div class="data-table-inner">
            <div class="data-header aisea-text-14-700-gray">
              <div class="first-column cell"></div>
              <div
                v-for="(header, index) in columnDefinitions" :key="index"
                class="header-cell cell" :class="header.key"
              >
                {{header.label}}
              </div>
            </div>
            <div class="data-content">
              <div class="data-row">
                <div
                  class="cell first-column aisea-text-14-700-white"
                >
                  実績航路
                </div>
                <div
                  class="cell data-cell"
                  v-for="(header, index) in columnDefinitions"
                  :key="index"
                  :class="header.key"
                >
                  <span class="data-value aisea-text-14-400-white">
                    <template v-if="actualVoyage[header.key].value != null" >{{actualVoyage[header.key].value}}{{actualVoyage[header.key].unit}}</template>
                  </span>
                  <span class="data-value data-diff aisea-text-14-400-blue">
                    <template v-if="actualVoyage[header.key].diff != null">{{actualVoyage[header.key].diff}}{{actualVoyage[header.key].unit}}</template>
                  </span>
                </div>
              </div>
              <div class="data-row" >
                <div
                  class="cell first-column aisea-text-14-700-white"
                >
                  ポラリス航路
                </div>
                <div
                  class="cell data-cell"
                  v-for="(header, index) in columnDefinitions"
                  :key="index"
                  :class="header.key"
                >
                  <span class="data-value aisea-text-14-400-white">
                    <template v-if="polarisVoyage[header.key].value != null">{{polarisVoyage[header.key].value}}{{polarisVoyage[header.key].unit}}</template>
                  </span>
                </div>
              </div>
              <div class="data-row" >
                <div
                  class="cell first-column aisea-text-14-700-white"
                >
                  計画航路
                </div>
                <div
                  class="cell data-cell"
                  v-for="(header, index) in columnDefinitions"
                  :key="index"
                  :class="header.key"
                >
                  <span class="data-value aisea-text-14-400-white">
                    <template v-if="plannedVoyage[header.key].value != null">{{plannedVoyage[header.key].value}}{{plannedVoyage[header.key].unit}}</template>
                  </span>
                  <span class="data-value data-diff aisea-text-14-400-blue">
                    <template v-if="plannedVoyage[header.key].diff != null">{{plannedVoyage[header.key].diff}}{{plannedVoyage[header.key].unit}}</template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import Mapbox from "mapbox-gl";
import moment from "moment";
import * as turf from '@turf/turf';
import LocalDbService from "@/services/localDbService";
import { MAP_STYLE_DEFAULT, MAP_STYLE_SATELLITE } from "@/config/const";
import 'mapbox-gl/dist/mapbox-gl.css'
const { mapActions, mapState } = createNamespacedHelpers("ecoShipVoyagePlan");

// Mixins
import {LocalizeMixin, DeviceInfoMixin, LayerMixin} from "@/mixins";

export default {
  mixins: [LocalizeMixin, DeviceInfoMixin, LayerMixin],
  data() {
    return {
      paramsToList: null,
      vesselName: null,
      seaRouteDestination: null,
      pilot: null,
      voyageDateTime: null,
      actualSeaRouteSwitch: true,
      plannedSeaRouteSwitch: true,
      polarisSeaRouteSwitch: true,
      actualFocusedSeaRoutePoint: {
        date: null,
        speed: null,
        time: null,
        distance: null
      },
      polarisFocusedSeaRoutePoint: {
        date: null,
        speed: null,
        time: null,
        distance: null
      },
      plannedFocusedSeaRoutePoint: {
        distance: null
      },
      map: null,
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      center: [139.92878, 35.56920],
      zoom: 8,
      mapStyleLocal: null,
      popupForWake: new Mapbox.Popup({
        closeButton: false,
        closeOnClick: false
      }),
      hovertedStateId: null,
      vesselId: null,
      imageDefault: require("@/assets/images/pages/map/streetmap.png"),
      imageSatellite: require("@/assets/images/pages/map/sattellite.png"),
      mapStyle: this.MAP_DEFAULT_STYLE_URL,
      actualVoyage: {
        prefix: "actual",
        positions: [],
        features: [],
        pointFeatures: [],
        focusMarker: null,
        lineColor: "#F6FB06",
        lineDasharray: [1],
        distance: {
          value: null,
          diff: null,
          unit: "mile"
        },
        time: {
          value: null,
          diff: null,
          unit: null
        },
        speed: {
          value: null,
          diff: null,
          unit: "mile/h"
        },
        gasoline: {
          value: null,
          diff: null,
          unit: "KL"
        },
        mile: {
          value: null,
          diff: null,
          unit: "KL/mile"
        },
      },
      plannedVoyage: {
        prefix: "planned",
        positions: [],
        features: [],
        pointFeatures: [],
        focusMarker: null,
        lineColor: "#828282",
        lineDasharray: [1,3],
        distance: {
          value: null,
          diff: null,
          unit: "mile"
        },
        time: {
          value: null,
          diff: null,
          unit: null
        },
        speed: {
          value: null,
          diff: null,
          unit: "mile/h"
        },
        gasoline: {
          value: null,
          diff: null,
          unit: "KL"
        },
        mile: {
          value: null,
          diff: null,
          unit: "KL/mile"
        },
      },
      polarisVoyage: {
        prefix: "polaris",
        positions: [],
        features: [],
        pointFeatures: [],
        focusMarker: null,
        lineColor: "#2D9CDB",
        lineDasharray: [1],
        distance: {
          value: null,
          diff: null,
          unit: "mile"
        },
        time: {
          value: null,
          diff: null,
          unit: null
        },
        speed: {
          value: null,
          diff: null,
          unit: "MN"
        },
        gasoline: {
          value: null,
          diff: null,
          unit: "KL"
        },
        mile: {
          value: null,
          diff: null,
          unit: "KL/mile"
        },
      },
      columnDefinitions: [
        {
          key: "distance",
          label: "航行距離"
        },
        {
          key: "time",
          label: "航行時間"
        },
        {
          key: "speed",
          label: "平均速力"
        },
        {
          key: "gasoline",
          label: "燃料油消費量"
        },
        {
          key: "mile",
          label: "平均マイル消費"
        },
      ]
    };
  },
  watch: {
    actualSeaRouteSwitch(value) {
      this.switchVisibility(value, "actual")
    },
    plannedSeaRouteSwitch(value) {
      this.switchVisibility(value, "planned")
    },
    polarisSeaRouteSwitch(value) {
      this.switchVisibility(value, "polaris")
    }
  },
  async created() {
    this.deviceInfo = this.getDeviceInfo()
    this.paramsToList = this.$route.params

    this.vesselName = this.seaRouteDetailCondition.vesselName
    this.pilot = this.seaRouteDetailCondition.pilot
    this.seaRouteDestination = this.seaRouteDetailCondition.seaRoute
    let start = moment(this.seaRouteDetailCondition.startedAt).format("YYYY/MM/DD HH:mm")
    let end = moment(this.seaRouteDetailCondition.endedAt).format("YYYY/MM/DD HH:mm")
    let dateTime = start +  " - " + end
    this.voyageDateTime = dateTime

    this.map = null;

    this.vesselId = this.seaRouteDetailCondition.vesselId
  },
  async mounted() {
    this.$vs.loading()

    let payload = {
      //requestId: "1234",//null,
      vesselId: this.seaRouteDetailCondition.vesselId,
      params: {
        started_at: this.seaRouteDetailCondition.startedAt,
        ended_at: this.seaRouteDetailCondition.endedAt,
      }
    }

    // 実航路
    let actualPositions = await this.fetchVoyageHistoryDetail(payload) // 実航路を取得
    if (actualPositions.points) {
      this.actualVoyage.features = this.createLineFeatures(actualPositions.points, "actual")
      this.actualVoyage.pointFeatures = this.createPointFeatures(actualPositions.points, "actual")

      this.actualVoyage.positions = actualPositions.points.map(element => {
        return [element.lon, element.lat]
      })
      if (this.actualVoyage.positions[0]) this.center = this.actualVoyage.positions[0]
    }

    // ポラリス航路と計画航路を取得
    payload = {
      requestId: "1234",
      vesselId: this.seaRouteDetailCondition.vesselId,
      voyageHistoryId: this.seaRouteDetailCondition.voyageId
    }
    await this.fetchSeaRouteDetail(payload)


    // 計画航路
    if (this.seaRoutes[0]) {
      this.plannedVoyage.positions = this.seaRoutes[0].map(element => {
        return [element.longitude, element.latitude]
      })
      this.plannedVoyage.features = this.createLineFeatures(this.seaRoutes[0], "planned")
      this.plannedVoyage.pointFeatures = this.createPointFeatures(this.seaRoutes[0], "planned")
    }

    // ポラリス航路
    if (this.seaRoutes[1]) {
      this.polarisVoyage.positions = this.seaRoutes[1].map(element => {
        return [element.longitude, element.latitude]
      })
      this.polarisVoyage.features = this.createLineFeatures(this.seaRoutes[1], "polaris")
      this.polarisVoyage.pointFeatures = this.createPointFeatures(this.seaRoutes[1], "polaris")
    }

    // データテーブルのデータ計算
    this.setDataTable()

    this.mapStyleLocal = await LocalDbService.getMapStyle();
    Mapbox.prewarm();
    Mapbox.maxParallelImageRequests = 10;
    Mapbox.accessToken = this.accessToken;
    this.map = new Mapbox.Map({
      container: "voyage-plan-map",
      style: this.mapStyleLocal,
      center: this.center,
      zoom: this.zoom
    });
    this.map.on("style.load", this.mapStyleLoad);

    let scale = new Mapbox.ScaleControl({
      maxWidth: 80,
      unit: "imperial"
    });

    if (!this.isMobileDevice){
      this.map.addControl(scale, "bottom-left");
      scale.setUnit("metric");
    }

    // マップスタイル変更ボタン
    const createMapStyleChangerButton = onclick => {
      const button = document.createElement("button");
      button.setAttribute("type", "button");
      button.classList.add("mapboxgl-ctrl-map-style-changer");
      button.appendChild(document.createElement("img"));
      button.children[0].classList.add("mapboxgl-ctrl-icon");
      button.children[0].src = this.imageSatellite;
      button.addEventListener("click", onclick);
      return button;
    };

    const mapStyleChangerButton = createMapStyleChangerButton(_ => {
      this.updateMapStyle();
    });

    const mapStyleChangerControl = {
      onAdd: _ => {
        this._container = document.createElement("div");
        this._container.classList.add("mapboxgl-ctrl", "mapboxgl-ctrl-group");
        this._container.classList.add("custom-control");
        this._container.appendChild(mapStyleChangerButton);
        return this._container;
      },
      getDefaultPosition: () => {
        return "top-right";
      },
      onRemove: () => {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    };
    this.map.addControl(mapStyleChangerControl);

    let nav = new Mapbox.NavigationControl();

    if (this.isMobileDevice) {
      this.map.addControl(nav, 'top-right');
      this.map.addControl(scale, "top-right");
    } else {
      this.map.addControl(nav, 'bottom-right');
    }

    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      seaRouteDetailCondition: state => state.seaRouteDetailCondition,
      seaRoutes: state => state.seaRoutes,
    }),
    isMobileDevice() {
      if (this.deviceInfo) {
        return this.deviceInfo.deviceType == "iPhone"
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      "fetchSeaRoute",
      "getVesselPositions",
      "fetchSeaRouteDetail",
      "fetchVoyageHistoryDetail"
    ]),
    convertSecondToHour(time) {
      let originalMinutes = Math.abs(time / 60)
      let hour = Math.floor(originalMinutes / 60)
      hour = ( '00' + hour ).slice( -2 )
      let min = Math.round(originalMinutes % 60)
      min = ( '00' + min ).slice( -2 )
      return `${hour}:${min}`
    },
    convertHourToSecond(time) {
      if (time == null) return 0
      let hourMinute = time.split(':')
      let hours = Number(hourMinute[0])
      let minutes = Number(hourMinute[1])
      let totalSeconds = hours * 60 * 60 + minutes * 60
      return totalSeconds
    },
    switchVisibility(visibility, prefix) {
      if (!visibility) {
        this.map.setLayoutProperty(
          prefix + '-' + 'line',
          'visibility',
          'none'
        );
        this.map.setLayoutProperty(
          prefix + '-' + 'route',
          'visibility',
          'none'
        );
        this.map.setLayoutProperty(
          prefix + '-' + 'point',
          'visibility',
          'none'
        );
      } else {
        this.map.setLayoutProperty(
          prefix + '-' + 'line',
          'visibility',
          'visible'
        );
        this.map.setLayoutProperty(
          prefix + '-' + 'route',
          'visibility',
          'visible'
        );
        this.map.setLayoutProperty(
          prefix + '-' + 'point',
          'visibility',
          'visible'
        );
      }
    },
    mapStyleLoad() {

      if (this.isDefaultMapStyle(this.mapStyleLocal)) {
        let lang = this.getBrowserLanguage()
        let local = "name_" + lang;
        if (this.map) {
          let textLayerIds = this.getTextLayerIds();
          textLayerIds.forEach(id => {
            this.map.setLayoutProperty(id, "text-field", ["get", local]);
          });
        }
      }

      this.addSource(this.actualVoyage, "actual")
      this.addLayers(this.actualVoyage, "actual")
      this.setMouseEvents(this.actualVoyage, "actual")

      this.addSource(this.plannedVoyage, "planned")
      this.addLayers(this.plannedVoyage, "planned")
      this.setMouseEvents(this.plannedVoyage, "planned")

      this.addSource(this.polarisVoyage, "polaris")
      this.addLayers(this.polarisVoyage, "polaris")
      this.setMouseEvents(this.polarisVoyage, "polaris")
    },
    createLineFeatures(pointList, prefix) {
      if (prefix == "actual") { //実航路とそれ以外ではデータの入りかたが変わる
        let totalDistance = 0
        let featureList = pointList.map((element, index) => {
          // 距離計算
          if (index != 0) {
            let formerPoint = turf.point([pointList[index - 1].lat, pointList[index - 1].lon])
            let currentPoint = turf.point([pointList[index].lat, pointList[index].lon])
            let distanceFromFormerPoint = turf.distance(formerPoint, currentPoint, {units: "nauticalmiles"})
            totalDistance = totalDistance + distanceFromFormerPoint
          }

          // 時間計算
          let diffSecond = moment(element.t).unix() - moment(pointList[0].t).unix()
          let elapsedTime = this.convertSecondToHour(diffSecond)

          // 速度計算
          let velocity = Math.round(element.v / 1.852)

          return {
            type: "Feature",
            properties: {
              id: prefix + "-line-" + index,
              datetime: moment(element.t).format("YYYY/MM/DD HH:mm"),
              elapsedTime: elapsedTime,
              distance: totalDistance,
              latitude: element.lat,
              longitude: element.lon,
              velocity: velocity
            },
            geometry: {
              'type': 'LineString',
              'coordinates': index > 0 ? [[element.lon, element.lat], [pointList[index - 1].lon, pointList[index - 1].lat]] : []
            }
          }
        })
        featureList = featureList.filter(element => element.geometry.coordinates.length != 0)
        return featureList
      } else { // ポラリス航路、計画航路の場合
        let totalDistance = 0
        let featureList = pointList.map((element, index) => {
          // 距離計算
          if (element.properties.AccumulatedDistance != null) {
            totalDistance = element.properties.AccumulatedDistance
          } else {
            if (index != 0) {
              let formerPoint = turf.point([pointList[index - 1].latitude, pointList[index - 1].longitude])
              let currentPoint = turf.point([pointList[index].latitude, pointList[index].longitude])
              let distanceFromFormerPoint = turf.distance(formerPoint, currentPoint, {units: "nauticalmiles"})
              totalDistance = totalDistance + distanceFromFormerPoint
            }
          }

          // 時間計算
          let elapsedTime = element.properties.AccumulatedHour ? this.convertSecondToHour(element.properties.AccumulatedHour * 60 * 60) : "00:00"

          // 速度計算
          let velocity = element.properties.SPTW ? element.properties.SPTW : 0

          // 燃料計算
          let fuelConsumption = element.properties.FuelConsumption ? element.properties.FuelConsumption : 0

          return {
            type: "Feature",
            properties: {
              id: prefix + "-line-" + index,
              datetime: element.properties.DateTime ? moment.utc(element.properties.DateTime).local().format("YYYY/MM/DD HH:mm") : 0,
              elapsedTime: elapsedTime,
              distance: totalDistance,
              latitude: element.latitude,
              longitude: element.longitude,
              velocity: velocity,
              fuelConsumption: fuelConsumption
            },
            geometry: {
              'type': 'LineString',
              'coordinates': index > 0 ? [[element.longitude, element.latitude], [pointList[index - 1].longitude, pointList[index - 1].latitude]] : []
            }
          }
        })
        featureList = featureList.filter(element => element.geometry.coordinates.length != 0)
        return featureList
      }
    },
    createPointFeatures(pointList, prefix) {
      if (prefix == "actual") { //実航路とそれ以外ではデータの入りかたが変わる
        let featureList = pointList.map((element, index) => {
          return {
            type: "Feature",
            properties: {
              id: prefix + "-point-" + index,
              datetime: moment(element.t).format("YYYY/MM/DD HH:mm"),
            },
            geometry: {
              'type': 'Point',
              'coordinates': [element.lon, element.lat]
            }
          }
        })
        return featureList
      } else { // ポラリス航路、計画航路の場合
        let featureList = pointList.map((element, index) => {
          return {
            type: "Feature",
            properties: {
              id: prefix + "-point-" + index,
              datetime: element.properties.DateTime ? moment.utc(element.properties.DateTime).local().format("YYYY/MM/DD HH:mm") : 0,
            },
            geometry: {
              'type': 'Point',
              'coordinates': [element.longitude, element.latitude]
            }
          }
        })
        featureList = featureList.filter(element => element.geometry.coordinates.length != 0)
        return featureList
      }
    },
    addSource(voyage, prefix) {
      let selfVoyage = voyage
      this.map.addSource(prefix + '-' + 'line-source', {
        'type': 'geojson',
        'promoteId': 'id',
        'data': {
          'type': 'Feature',
          'properties': {
            id: prefix + "-line",
          },
          'geometry': {
            'type': 'LineString',
            'coordinates': selfVoyage.positions
          }
        }

      })

      this.map.addSource(prefix + '-' + 'point-source', {
        'type': 'geojson',
        'promoteId': 'id',
        'data': {
          'type': 'FeatureCollection',
          'features': selfVoyage.pointFeatures
        }
      })

      this.map.addSource(prefix + '-' + 'line-event-source', {
        'type': 'geojson',
        'promoteId': 'id',
        'data': {
          'type': 'FeatureCollection',
          'features': selfVoyage.features
        },
      })
    },
    addLayers(voyage, prefix) {
      this.map.addLayer({
        'id': prefix + '-' + 'route',
        'type': 'line',
        'source': prefix + '-' + 'line-source',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round',
          'visibility': 'visible',
        },
        'paint': {
          'line-color': [
            'case',
            ['boolean',['feature-state', 'clicked'], false],
            voyage.lineColor, // if selected true, paint in blue
            voyage.lineColor // else paint in gray
          ],
          'line-width': 3,
          'line-dasharray': voyage.lineDasharray
        }
      });

      this.map.addLayer({
        'id': prefix + '-' + 'point',
        'type': 'circle',
        'source': prefix + '-' + 'point-source',
       'visibility': 'none',
        'paint': {
          'circle-radius': [
            'case',
            ['boolean',['feature-state', 'focused'], false],
            6,
            0
          ],
          'circle-color': voyage.lineColor,
          'circle-stroke-color': voyage.lineColor,
          'circle-stroke-width': 2,
          'circle-stroke-opacity': 0.5
        }
      });

      this.map.addLayer({
        'id': prefix + '-' + 'line',
        'type': 'line',
        'source': prefix + '-' + 'line-event-source',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round',
          'visibility': 'visible',
        },
        'paint': {
          "line-width": 20.0,
          "line-opacity": 0
        }
      });
    },
    updateMapStyle() {
      let el = document.getElementsByClassName(
        "mapboxgl-ctrl-map-style-changer"
      );
      if (this.mapStyleType === 1) {
        el[0].lastChild.src = this.imageSatellite;
        this.mapStyleType = 2;
        this.map.setStyle(MAP_STYLE_DEFAULT);
        this.mapStyleLocal = MAP_STYLE_DEFAULT
      } else {
        el[0].lastChild.src = this.imageDefault;
        this.mapStyleType = 1;
        this.map.setStyle(MAP_STYLE_SATELLITE);
        this.mapStyleLocal = MAP_STYLE_SATELLITE
      }
    },
    setMouseEvents(voyage, prefix) {
      if (prefix == "planned") return // plannedの場合はデータがないためフォーカスポイントを表示しない

      let self = this;
      this.map.on(
        "mousemove",
        prefix + '-' + 'line',
        e => {
          self.setCursor(true, self);
          var features = this.map.queryRenderedFeatures(e.point);
          self.showWakeLineInfoPopup(e, self, prefix)

          let voyages = []
          let anotherVoyagePrefix = null
          if (prefix == "actual") {
            voyages = [this.actualVoyage, this.polarisVoyage]
            anotherVoyagePrefix = "polaris"
          } else if (prefix == "polaris") {
            voyages = [this.polarisVoyage, this.actualVoyage]
            anotherVoyagePrefix = "actual"
          }

          let targetTime = moment(features[0].properties.datetime).unix()
          let index = null

          // ホバーしていない方の航路にフォーカスポイントを設定
          if ((anotherVoyagePrefix == 'polaris' && this.polarisSeaRouteSwitch) || (anotherVoyagePrefix == 'actual' && this.actualSeaRouteSwitch)) {
            let anotherVoyageTimeList = voyages[1].features.map(element => moment(element.properties.datetime).unix())
            index = anotherVoyageTimeList.findIndex(element => targetTime < element)
            if (index < 0) {
              index = anotherVoyageTimeList.length
            } else {
              index++
            }

            // フォーカスポイントのデータをlineFeatureから参照

            //self[`${anotherVoyagePrefix}Voyage`].features

            // 前のフォーカスポイントと異なっていたら前のポイントを無効にし、新しいポイントを有効にする
            if (voyages[1].focusMarker) {
              this.map.setFeatureState({
                source: anotherVoyagePrefix + '-' + 'point-source',
                id: anotherVoyagePrefix + '-point-' + voyages[1].focusMarker,
              }, {
                focused: false
              });

              let properties = self[`${anotherVoyagePrefix}Voyage`].features[index-1].properties
              let datetime = properties.datetime
              let distance = Math.round(properties.distance * 100) / 100
              let velocity = properties.velocity
              let elapsedTime = properties.elapsedTime
              self[`${anotherVoyagePrefix}FocusedSeaRoutePoint`] = {
                date: datetime,
                speed: velocity,
                time: elapsedTime,
                distance: distance
              }
              /*
              actualFocusedSeaRoutePoint: {
                date: null,
                speed: null,
                time: null,
                distance: null
              },
              */

            }
            // 前のフォーカスポイントとして新しいポイントを保存
            voyages[1].focusMarker = index

            this.map.setFeatureState({
              source: anotherVoyagePrefix + '-' + 'point-source',
              id: anotherVoyagePrefix + '-point-' + index,
            }, {
              focused: true
            });
          }

          // ホバーしている方の航路にフォーカスポイントを設定
          if ((prefix == 'polaris' && this.polarisSeaRouteSwitch) || (prefix == 'actual' && this.actualSeaRouteSwitch)) {
            let selfVoyageTimeList = voyages[0].features.map(element => moment(element.properties.datetime).unix())
            index = selfVoyageTimeList.findIndex(element => targetTime == element)
            if (index < 0) {
              index = selfVoyageTimeList.length
            } else {
              index++
            }

            if (voyages[0].focusMarker && voyages[0].focusMarker != index) {
              this.map.setFeatureState({
                source: prefix + '-' + 'point-source',
                id: prefix + '-point-' + voyages[0].focusMarker,
              }, {
                focused: false
              });
            }
            voyages[0].focusMarker = index

            this.map.setFeatureState({
              source: prefix + '-' + 'point-source',
              id: prefix + '-point-' + index,
            }, {
              focused: true
            });
          }
        }
      );
      this.map.on(
        "mouseleave",
        prefix + '-' + 'line',
        e => {
          self.setCursor(false, self);
          self.removePopup(e, self, prefix);

          let voyages = [this.actualVoyage, this.polarisVoyage]
          for (const element of voyages) {
            this.map.setFeatureState({
              source: element.prefix + '-' + 'point-source',
              id: element.prefix + '-point-' + element.focusMarker,
            }, {
              focused: false
            });

            self[`${element.prefix}FocusedSeaRoutePoint`] = {
              date: null,
              speed: null,
              time: null,
              distance: null
            }
          }
        }
      );
    },

    setCursor(isPointer, self) {
      self.map.getCanvas().style.cursor = isPointer ? "pointer" : "";
    },

    removeAllFocusPoints() {
      if (this.actualVoyage.focusMarker) {
        this.actualVoyage.focusMarker.remove()
        this.actualVoyage.focusMarker = null
      }
      /*
      if (this.plannedVoyage.focusMarker) {
        this.plannedVoyage.focusMarker.remove()
        this.plannedVoyage.focusMarker = null
      }
      */
      if (this.polarisVoyage.focusMarker) {
        this.polarisVoyage.focusMarker.remove()
        this.polarisVoyage.focusMarker = null
      }
    },

    showWakeLineInfoPopup(e, self, prefix) {
      if (prefix == "planned") return // 計画航路はpropertiesをもっていないのでポップアップを表示しない

      // let coordinates = [e.lngLat.lng, e.lngLat.lat];
      let properties = e.features[0].properties
      let datetime = properties.datetime
      let distance = Math.round(properties.distance * 100) / 100
      let velocity = properties.velocity
      let elapsedTime = properties.elapsedTime

      this[`${prefix}FocusedSeaRoutePoint`] = {
        date: datetime,
        speed: velocity,
        time: elapsedTime,
        distance: distance
      }

      /*
      let description = `
      <span class="mr-2">${datetime}</span>
      <div class="mr-2">速力: ${velocity}KN</div>
      <div class="mr-2">時間: ${elapsedTime}</div>
      <div class="mr-2">距離: ${distance}mile</div>
      `;
      self.popupForWake
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(self.map);
      */
    },

    removePopup(e, self, _) {
      self.popupForWake.remove();
    },

    setDataTable() {
      if (this.seaRoutes[1]) {
        this.polarisVoyage.gasoline.value = this.polarisVoyage.features[this.polarisVoyage.features.length - 1].properties.fuelConsumption
        this.polarisVoyage.distance.value = this.roundNumber(this.polarisVoyage.features[this.polarisVoyage.features.length - 1].properties.distance)
        this.polarisVoyage.time.value = this.polarisVoyage.features[this.polarisVoyage.features.length - 1].properties.elapsedTime
        this.polarisVoyage.mile.value = this.isOperandExist(this.polarisVoyage.gasoline.value, this.polarisVoyage.distance.value) ?
          this.roundNumber(this.polarisVoyage.gasoline.value / this.polarisVoyage.distance.value) : null
        this.polarisVoyage.speed.value = this.roundNumber(this.polarisVoyage.features.map(element => element.properties.velocity).reduce((accumulator, current) => accumulator + current) / this.polarisVoyage.features.length)
      }

      if (this.seaRouteDetailCondition) {
        this.actualVoyage.gasoline.value = this.roundNumberK(this.seaRouteDetailCondition.totalPetrol)
        this.actualVoyage.distance.value = this.roundNumber(this.seaRouteDetailCondition.distance)
        this.actualVoyage.time.value = this.seaRouteDetailCondition.time
          ? Math.floor(this.seaRouteDetailCondition.time) + ":" + Math.floor((this.seaRouteDetailCondition.time - Math.floor(this.seaRouteDetailCondition.time)) * 100)
          : (this.actualVoyage.features.length > 0 ? this.actualVoyage.features[this.actualVoyage.features.length - 1].properties.elapsedTime : null)
        this.actualVoyage.mile.value = this.roundNumberK(this.seaRouteDetailCondition.mile)
        this.actualVoyage.speed.value = this.roundNumber(this.seaRouteDetailCondition.speed)

        this.actualVoyage.gasoline.diff = this.isOperandExist(this.actualVoyage.gasoline.value, this.polarisVoyage.gasoline.value) ?
          this.roundNumber(this.actualVoyage.gasoline.value - this.polarisVoyage.gasoline.value) : null
        this.actualVoyage.distance.diff = this.isOperandExist(this.actualVoyage.distance.value, this.polarisVoyage.distance.value) ?
          this.roundNumber(this.actualVoyage.distance.value - this.polarisVoyage.distance.value) : null
        if (this.actualVoyage.time.value != null && this.polarisVoyage.time.value != null) {
          let actualDiffSeconds = this.convertHourToSecond(this.actualVoyage.time.value) - this.convertHourToSecond(this.polarisVoyage.time.value)
          this.actualVoyage.time.diff = actualDiffSeconds / 60 + "min"
        }
        this.actualVoyage.mile.diff = this.isOperandExist(this.actualVoyage.mile.value, this.polarisVoyage.mile.value) ?
          this.roundNumber(this.actualVoyage.mile.value - this.polarisVoyage.mile.value) : null
        this.actualVoyage.speed.diff = this.isOperandExist(this.actualVoyage.speed.value, this.polarisVoyage.speed.value) ?
          this.roundNumber(this.actualVoyage.speed.value - this.polarisVoyage.speed.value) : null
      }

      if (this.seaRoutes[0]) {
        this.plannedVoyage.distance.value = this.roundNumber(this.plannedVoyage.features[this.plannedVoyage.features.length - 1].properties.distance)

        this.plannedVoyage.distance.diff = this.isOperandExist(this.plannedVoyage.distance.value, this.polarisVoyage.distance.value) ?
          this.roundNumber(this.plannedVoyage.distance.value - this.polarisVoyage.distance.value) : null
      }
    },
    roundNumber(target) {
      return typeof target == 'number' && !isNaN(target) ? Math.round(target * 100) / 100 : null
    },
    roundNumberK(target) {
      return typeof target === 'number' && !isNaN(target) ? Math.round(target / 10) / 100 : null
    },
    isOperandExist(a, b) {
      return a != null && b != null
    },
    convertToDiffString(value) {
      if (typeof value == "string" || value < 0) {
        return value
      } else if (value >= 0) {
        return "+" + value
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
#voyage-plan-detail {
  #voyage-plan-map {
    background: $aisea-dark-blue !important;
  }
  .actual-voyage-focus-point {
    width: 10px;
    height: 10px;
    border-radius: 8px;
    border: solid 2px #ffffff74;
    background-color: $aisea-yellow;
  }
  .polaris-voyage-focus-point {
    width: 10px;
    height: 10px;
    border-radius: 8px;
    border: solid 2px #ffffff74;
    background-color: $aisea-blue;
  }
  .voyage-plan-detail-inner {
    &.mobile {
      padding: 0;
      background: transparent;
      .select-box {
        width: 130px !important;
        margin-right: 10px !important;
      }
      .control-area-block {
        .vs-button {
          padding: 0.75rem 1rem;
        }
        .vs__search {
          max-width: 0px;
          max-height: 0px;
          margin: 0;
          padding: 0;
        }
      }
    }
  }
  .mapboxgl-ctrl-map-style-changer {
    height: 40px !important;
    width: 60px !important;
    .mapboxgl-ctrl-icon {
      border-radius: 4px;
    }
  }
  .vessel-name-title-area {
    display: flex;
    align-items: center;
    .back-to-list-button {
      height: 20px;
      cursor: pointer;
      color: #2D9CDB !important;
    }
    .vessel-name-text {
      margin-right: 20px;
    }
  }
  .back-to-list-button {
    display: flex;
  }
  .upper-control-area {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    .control-area-block {
      display: flex;
      align-items: center;
      height: 42px;
      .control-area-label {
        margin-right: 15px;
        font-weight: bold;
      }
      .control-area-text {
        margin-right: 30px;
      }
      .select-box {
        width: 180px;
        margin-right: 30px;
      }
    }

  }
  .main-voyage-plan-container {
    display: flex;
    flex-wrap: wrap;
    &.mobile {
      position: relative;
      min-height: 0px;
      #voyage-plan-map {
        width: 100%;
        height: calc(100vh - 240px);
        position: relative;
      }
      .voyage-plan-control-wrapper {
        height: fit-content;
        width: 99%;
        left: 1px;
        overflow: scroll;
        position: absolute;
        bottom: 10px;
        .voyage-plan-control-area {
          position: relative;
          overflow-x: scroll;
          display: flex;
          width: fit-content;
          height: fit-content;
          flex-wrap: nowrap;
          padding: 8px 0px;
          .control-area-switch-container {
            border-bottom: 0px;
            width: 150px;
            padding: 0px 0px;
            min-height: 44px;
          }
        }
      }
    }
    #voyage-plan-map {
      display: flex;
      flex-grow: 1;
      background: #BBB;
      height: calc(100vh - 260px);
      min-height: 231px;
    }

    .voyage-plan-control-area {
      position: absolute;
      width: 190px;
      margin-left: 10px;
      margin-top: 10px;
      border-radius: 8px;
      padding-top: 10px;
      padding-bottom: 10px;
      background: rgba(44, 50, 65, 0.8);
      color: #fff;
      .focused-route-info-text {
        min-height: 22px;
      }
      .control-area-title {
        padding: 15px 0px;
        margin: 0px 15px;
        border-bottom: 1px solid #828282;
      }
      .control-area-switch-container {
        // display: flex;
        // align-items: center;
        // padding: 15px 0px;
        margin: 0px 15px;
        border-bottom: 1px solid #828282;
        .upper-switch-container {
          display: flex;
          align-items: center;
          padding: 15px 0px;
          // margin: 0px 15px;
        }
        .control-switch {
          margin-left: auto;
        }
        .yellow-circle, .blue-circle, .gray-circle {
          min-width: 12px;
          height: 12px;
          border-radius: 7px;
          margin-right: 10px;
        }
        .yellow-circle {
          background: $aisea-yellow;
        }
        .blue-circle {
          background: $aisea-blue;
        }
        .gray-circle {
          background: $aisea-gray;
        }
      }
    }
  }
  .footer-voyage-plan-area {
    background: #2C3241;
    height: 182px;
    display: flex;
    .data-header {
      display: flex;
      height: 29px;
      .header-cell {
        width: 15%;
        display: flex;
        align-items: flex-end;
      }
    }

    .data-row {
      display: flex;
      width: 100%;
      border-top: solid 1px;
      height: 50px;
    }
    .data-table {
      width: 100%;
      overflow: scroll;
      .data-table-inner {
        min-width: 1000px;
      }
    }
    .first-column {
      width: 200px;
      padding-left: 28px;
      display: flex;
      align-items: center;
    }
    .data-cell {
      width: 15%;
      display: flex;
      align-items: center;
      overflow-wrap: anywhere;
      .data-diff {
        padding-left: 13px;
      }
    }
    .cell {
      margin-right: 8px;
    }
  }
}

</style>
